import { useEffect } from 'react';
import { createClient } from '../../prismicio';
import MetaHead from 'common/components/MetaHead';
import { Mixpanel } from 'utils/mixpanel';
import PricingPage from 'containers/SaasModern/PricingPage';
import Page from 'containers/SaasModern/Page';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';

export default function pricingPage({ locale, data, promotion }) {

  useEffect(() => {
    Mixpanel.track('Pricing view', {
      'Pricing title': 'Pricing',
    });
  }, []);

  return ( 
    <Page locale={locale} promotion={promotion}>
      <MetaHead
        title={data?.meta_title}
        description={data?.meta_description}
        keywords={data?.meta_keywords}
        imageUrl={data?.meta_image?.url}
      />
      <PricingPage
        data={data}
        locale={locale}
        
      />
    </Page>
  );
}

export const getStaticProps = async ({ locale}) => {
  const client = createClient();
  const prismicLanguage = getPrismicLanguage(locale);
   try {
  const pricing_page = await client.getSingle('pricing_page', {
    lang: prismicLanguage,
  });
  // Safely fetch 'sold' document with error handling
    let sold = null;
    try {
      sold = await client.getSingle('sold', {
        lang: prismicLanguage,
      });
    } catch (error) {
      console.warn('Sold document not found, using null as fallback');
      sold = { data: null };
    }

  const homepage = await client.getSingle('homepage', {
    lang: prismicLanguage,
  });
  
  const subPlansTokenUsageData = await fetch(
    'https://graphql.swiftask.ai/public/subplans_token_usage',
  );
  const botsUseCaseLabelData = await fetch(
    'https://graphql.swiftask.ai/public/bots_use_case',
  ); 
  const botsUseCaseLabel = await botsUseCaseLabelData.json();
  const subPlansTokenUsage = await subPlansTokenUsageData.json();
  return {
    props: {
      locale:prismicLanguage,
      promotion: sold.data,
      data: {
        ...pricing_page.data,
        subPlansTokenUsage,
        botsUseCaseLabel,
        faq: homepage.data.slices.filter((slice) => slice.slice_type === 'faq'),
      },
    
    },
  };
      } catch (error) {
    console.error('Error in getStaticProps:', error);
    throw error;
  }
};
